import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "results"]
  static values = { url: String }

  connect() {
    this.onDocumentClick = this.onDocumentClick.bind(this)
    this.onDocumentKeydown = this.onDocumentKeydown.bind(this)
    document.addEventListener("click", this.onDocumentClick)
    document.addEventListener("keydown", this.onDocumentKeydown)
  }

  disconnect() {
    document.removeEventListener("click", this.onDocumentClick)
    document.removeEventListener("keydown", this.onDocumentKeydown)
    clearTimeout(this.timer)
    this.request?.abort()
  }

  search() {
    clearTimeout(this.timer)
    this.request?.abort()

    const query = this.inputTarget.value.trim()
    if (query.length < 2) {
      this.close()
      return
    }

    this.timer = setTimeout(() => this.load(query), 180)
  }

  open() {
    if (this.resultsTarget.innerHTML.trim() !== "") this.resultsTarget.hidden = false
  }

  close() {
    this.resultsTarget.hidden = true
  }

  onDocumentClick(event) {
    if (!this.element.contains(event.target)) this.close()
  }

  onDocumentKeydown(event) {
    const target = event.target
    const isTyping = target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement || target?.isContentEditable

    if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === "k") {
      event.preventDefault()
      this.inputTarget.focus()
      this.inputTarget.select()
    } else if (event.key === "/" && !isTyping) {
      event.preventDefault()
      this.inputTarget.focus()
    } else if (event.key === "Escape" && this.element.contains(document.activeElement)) {
      this.close()
      this.inputTarget.blur()
    }
  }

  async load(query) {
    this.request = new AbortController()
    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("q", query)
    url.searchParams.set("compact", "1")

    try {
      const response = await fetch(url, {
        headers: { Accept: "text/html" },
        signal: this.request.signal
      })
      if (!response.ok || response.redirected) return

      this.resultsTarget.innerHTML = await response.text()
      this.resultsTarget.hidden = false
    } catch (error) {
      if (error.name !== "AbortError") this.close()
    }
  }
}
